
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
const borderStory = (args) => {
  const classNames = [args.width || ''];
  if (args.color) {
    classNames.push(args.color);
  }
  const className = classNames
    .map((segment) => (segment.length > 0 ? `u-border-${segment}` : 'u-border'))
    .join(' ');
  return `<div class="${className} u-pad-n1">${className}</div>`;
};


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Utilities/Border" argTypes={{
      width: {
        options: ['small', 'medium', 'large', 'none'],
        type: {
          name: 'enum'
        },
        control: {
          type: 'inline-radio'
        }
      }
    }} mdxType="Meta" />
    <h1>{`Border`}</h1>
    <p>{`These utilities apply borders. They may be used to visually offset content from its surroundings. For example, a screenshot in an article with a white background might blend in too much with the page without a border.`}</p>
    <h2>{`Sizes`}</h2>
    <p>{`Available sizes are based on `}<a parentName="p" {...{
        "href": "/?path=/docs/design-tokens-size--page#edge"
      }}>{`our `}<inlineCode parentName="a">{`size.$edge-`}</inlineCode>{` tokens`}</a>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`u-border`}</inlineCode>{` or `}<inlineCode parentName="li">{`u-border-small`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`u-border-medium`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`u-border-large`}</inlineCode></li>
    </ul>
    <Canvas mdxType="Canvas">
  <Story name="Small (Default)" mdxType="Story">{args => borderStory(args)}</Story>
  <Story name="Medium" args={{
        width: 'medium'
      }} mdxType="Story">
    {args => borderStory(args)}
  </Story>
  <Story name="Large" args={{
        width: 'large'
      }} mdxType="Story">
    {args => borderStory(args)}
  </Story>
  <Story name="None" args={{
        width: 'none'
      }} mdxType="Story">
    {args => borderStory(args)}
  </Story>
    </Canvas>
    <h2>{`Color and style`}</h2>
    <p>{`If no `}<inlineCode parentName="p">{`border-color`}</inlineCode>{` is set, these utilities will use the default border color of the current `}<a parentName="p" {...{
        "href": "/?path=/docs/design-themes--light"
      }}>{`theme`}</a>{`. If no `}<inlineCode parentName="p">{`border-style`}</inlineCode>{` is set, the utility will use `}<inlineCode parentName="p">{`solid`}</inlineCode>{`.`}</p>
    <p>{`We may add specific color and style utilities in the future as the need arises.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const smallDefault = (args => borderStory(args));
smallDefault.storyName = 'Small (Default)';
smallDefault.parameters = { storySource: { source: 'args => borderStory(args)' } };

export const medium = (args => borderStory(args));
medium.storyName = 'Medium';
medium.args = {
  width: 'medium'
};
medium.parameters = { storySource: { source: 'args => borderStory(args)' } };

export const large = (args => borderStory(args));
large.storyName = 'Large';
large.args = {
  width: 'large'
};
large.parameters = { storySource: { source: 'args => borderStory(args)' } };

export const none = (args => borderStory(args));
none.storyName = 'None';
none.args = {
  width: 'none'
};
none.parameters = { storySource: { source: 'args => borderStory(args)' } };

const componentMeta = { title: 'Utilities/Border', argTypes: {
  width: {
    options: ['small', 'medium', 'large', 'none'],
    type: {
      name: 'enum'
    },
    control: {
      type: 'inline-radio'
    }
  }
}, includeStories: ["smallDefault","medium","large","none"],  };

const mdxStoryNameToKey = {"Small (Default)":"smallDefault","Medium":"medium","Large":"large","None":"none"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;